import { render, staticRenderFns } from "./tabWarehouseTrucking.vue?vue&type=template&id=740e0710&"
import script from "./tabWarehouseTrucking.vue?vue&type=script&lang=js&"
export * from "./tabWarehouseTrucking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('740e0710')) {
      api.createRecord('740e0710', component.options)
    } else {
      api.reload('740e0710', component.options)
    }
    module.hot.accept("./tabWarehouseTrucking.vue?vue&type=template&id=740e0710&", function () {
      api.rerender('740e0710', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/components/AeBooking/tabs/tabWarehouseTrucking.vue"
export default component.exports